function injectStyle (ssrContext) {
  require("!!../../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-7cd63040\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../vue-loader/lib/selector?type=styles&index=0!./modal.vue")
}
var normalizeComponent = require("!../../../../vue-loader/lib/component-normalizer")
/* script */
import __vue_script__ from "!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./modal.vue"
/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/modal/modal.vue
// module id = JCpY
// module chunks = 1